import { createSelector } from 'reselect';
const getFileUploadSuccessState = (state) => {
    return state.domain.file.fileUploadSuccess;
};
const selectFileInfoId = (state, id, headerKey) => id;
const selectResponseHeaderKey = (state, id, headerKey) => headerKey;
export const getFileUploadSuccessByFileId = createSelector([getFileUploadSuccessState, selectFileInfoId], (fileUploadSuccessState, fileInfoId) => (fileUploadSuccessState && fileUploadSuccessState.byId[fileInfoId]) || undefined);
export const getFileUploadSuccessHeaderByHeaderKey = createSelector([getFileUploadSuccessState, selectFileInfoId, selectResponseHeaderKey], (fileUploadSuccessState, fileInfoId, responseHeaderKey) => {
    const headers = responseHeaderKey &&
        fileUploadSuccessState &&
        fileUploadSuccessState.byId[fileInfoId] &&
        fileUploadSuccessState.byId[fileInfoId].headers;
    return headers && headers[responseHeaderKey.toLowerCase()];
});
//# sourceMappingURL=getFileUploadSuccessState.js.map